import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ReadCookie from '../../../functions/readcookies';
import Switch from '@material-ui/core/Switch';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import jsPDF from 'jspdf';
import Mrp from './relatedinfo';
import { Grid } from 'semantic-ui-react';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class View extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'lg',
    paymentmode: [],
    editItems: false,
    quotationDetails: [],
    editQuotation: [],
    viewEdit: '',
  };

  componentDidMount() {
    this.menuControl();
  }


  menuControl() {
    let menuControl = this.props.menus;
    menuControl.map((z) => {
      if (z.menu == 'quotation') {
        if (z.edit == 1) {
          this.setState({ viewEdit: 'show' })
        }
        else {
          this.setState({ viewEdit: 'none' })
        }
      }
    })
  }

  getOrderDetails() {
    let context = this;
    let data1 = { 'id': this.props.viewId, 'masterId': this.props.masterId };
    context.setState({ load: true, message: 'Getting Order details!!!' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'quotation/getorder.php',
      success: function(data) {
        let remarks = '';
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1; data[i].sino = s + i;
            data[i].id = data[i].partnumber; remarks = data[i].info;
          }
          context.setState({ quotationDetails: data, open: true, remarks: remarks, load: false, })
        } catch (e) {
          console.log(e);
          context.setState({ load: false });
        }
      },
      error: function(err) {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }


  pdfGenerate() {
    let open = Server() + "pdf/placeorderpdf2.php?quotationId="+this.props.viewId+"&customerId="+this.props.customerId+"&bankId=0";
    window.open(open);
  }

  handleClose() {
    this.setState({ dialog: false })
  }

  handleCloseAndUpdate() {
    this.setState({ dialog: false });
    this.getOrderDetails();
  }

  close() {
    this.setState({ open: false })
    this.props.handleClose();
  }

  render() {
    const { classes } = this.props;
    let total = 0;
    return (
      <React.Fragment>
        <div onClick={this.getOrderDetails.bind(this)}>View</div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.close.bind(this)}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">View Order Details</DialogTitle>
          <DialogContent>
            <div>
              <table id="table" width="100%">
                <tr>
                  <th><center>Sino</center></th>
                  <th><center>Part Name</center></th>
                  <th><center>Brand Name</center></th>
                  <th><center>Stocks</center></th>
                  <th><center>Cost</center></th>
                  <th><center>Discount(%)</center></th>
                  <th><center>Discount(Rs)</center></th>
                  <th><center>TAX</center></th>
                  <th><center>Total</center></th>
                  <th><center>Info</center></th>
                </tr>
                { this.state.quotationDetails.map((z) => {
                  let value = z.totprice;
                  let cost = z.uprice;
                  let disc = z.disc;
                  let discper = z.discper;
                  try {
                    value = Number(value);
                    total = Number(total);
                    cost = Number(cost).toFixed(2);
                    discper = Number(discper).toFixed(1);
                    disc = Number(disc).toFixed(2);
                  } catch (e) {
                    value = 0;
                  }
                   total = total + value;
                    return(
                      <tr>
                        <td><center>{z.sino}</center></td>
                        <td>
                          { z.partnumber != '0' ?
                            (<div>{z.partnumber+'->'+z.sparename}</div>) :
                            (<div>{z.sparename}</div>)
                          }
                        </td>
                        <td><center>{z.brandname}</center></td>
                        <td><center>{z.qty}</center></td>
                        <td><center>{cost}</center></td>
                        <td><center>{discper}</center></td>
                        <td><center>{disc}</center></td>
                        <td><center>{z.tax}</center></td>
                        <td><center>{z.totprice}</center></td>
                        <td><center>
                          <Mrp viewDisplay='none' partno={z.partnumber}
                               partcodeOption={this.state.quotationDetails}
                               aliasId={z.partnumber} brand_id={z.brand_id} />
                        </center></td>
                      </tr>
                    );
                  })
                }
              </table>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Remarks: {this.state.remarks}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <div align='right' style={{margin: '2%', fontSize: 18}}>{'Rs.'+total.toFixed(2)}</div>
                </Grid.Column>
              </Grid>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.pdfGenerate.bind(this)} color="primary">
              Download PDF
            </Button>
            <Button onClick={this.close.bind(this)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

View.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
